import { mapGetters } from 'vuex'

export default {
    data() {
        return {
            isCaptchaPassed: false
        }
    },
    computed: {
        ...mapGetters({
            isCasaDelTabaco: 'global/getIsCasaDelTabaco'
        }),
    },
    components: { 
        Captcha: () => import('~/components/helpers/Captcha')
    },
    methods: {
        showCaptcha(isSubmited) {
            return this.isCasaDelTabaco && isSubmited
        },
        invalidCaptchaPass(isSubmited) {
            const condition = isSubmited && !this.isCaptchaPassed ? true : false
            return this.isCasaDelTabaco ? condition : false
        },
        resetCaptchaPass() {
            this.isCaptchaPassed = false
        },
        onVerify() {
            this.isCaptchaPassed = true
        },
    },
}